import React from "react";
import { Box } from "../primitives";
import { CardMarketSellerType } from "magic-shared-types";
import { FaTrash } from "react-icons/fa";
import { StrategyCardContainer } from "./StrategyCard.styled";

interface StrategyCardProps {
  id: number;
  name: string;
  feedback: number;
  same_language: boolean;
  ex_same_as_nm: boolean;
  strategy: string;

  seller_type?: CardMarketSellerType;
  only_fast_seller?: boolean;
  only_zero_seller?: boolean;
  location?: string;
  exclude_sellers?: string;
  min_price?: number;

  setSelectedStrategy?: (arg1: number) => void;
  selectedStrategy?: number;
  onDelete?: (arg1: number) => void;
}

export const StrategyCard: React.FC<StrategyCardProps> = ({
  name,
  location,
  feedback,
  same_language,
  ex_same_as_nm,
  only_fast_seller = undefined,
  only_zero_seller = undefined,
  strategy,
  seller_type,
  setSelectedStrategy,
  selectedStrategy,
  exclude_sellers,
  id,
  min_price,
  onDelete,
}) => {
  return (
    <StrategyCardContainer
      isSelected={selectedStrategy === id}
      onClick={() => {
        setSelectedStrategy?.(id);
      }}
    >
      {typeof onDelete === "function" && (
        <Box
          css={{
            position: "absolute",
            bottom: 10,
            right: 10,
            cursor: "pointer",
            zIndex: 10,
          }}
          onClick={async () => {
            onDelete(id);
          }}
        >
          <FaTrash size={18} color="red" />
        </Box>
      )}
      <Box
        css={{
          fontSize: "18px",
          fontWeight: "600",
          marginBottom: "12px",
          color: "#333",
        }}
      >
        {name}
      </Box>
      <Box
        css={{
          fontSize: "14px",
          color: "#666",
          lineHeight: "1.8",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <Box>
          <strong>Location:</strong> {location || "All"}
        </Box>
        <Box>
          <strong>Minimum Feedback:</strong> {feedback}
        </Box>
        <Box>
          <strong>Minimum Price:</strong> {min_price}
        </Box>
        <Box>
          <strong>Same Language:</strong> {same_language ? "Yes" : "No"}
        </Box>
        <Box>
          <strong>Ex Same as NM:</strong> {ex_same_as_nm ? "Yes" : "No"}
        </Box>
        <Box
          css={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          <strong>Seller excluded</strong> {exclude_sellers || "None"}
        </Box>
        <Box>
          <strong>Seller type:</strong> {seller_type}
        </Box>
        {only_fast_seller !== undefined && (
          <Box>
            <strong>Only Fast Seller:</strong> {only_fast_seller ? "Yes" : "No"}
          </Box>
        )}
        {only_zero_seller !== undefined && (
          <Box>
            <strong>Only Zero Seller:</strong> {only_zero_seller ? "Yes" : "No"}
          </Box>
        )}
        <Box>
          <strong>Strategy Type:</strong> {strategy}
        </Box>
      </Box>
    </StrategyCardContainer>
  );
};
